var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3C5.85786 3 2.5 6.35786 2.5 10.5C2.5 14.6421 5.85786 18 10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35786 14.1421 3 10 3ZM3.86364 10.5C3.86364 7.11098 6.61098 4.36364 10 4.36364C13.389 4.36364 16.1364 7.11098 16.1364 10.5C16.1364 13.889 13.389 16.6364 10 16.6364C6.61098 16.6364 3.86364 13.889 3.86364 10.5Z",
    fill: "#747D93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68306 8.18306C7.92714 7.93898 8.32286 7.93898 8.56694 8.18306L10 9.61612L11.4331 8.18306C11.6771 7.93898 12.0729 7.93898 12.3169 8.18306C12.561 8.42714 12.561 8.82286 12.3169 9.06694L10.8839 10.5L12.3169 11.9331C12.561 12.1771 12.561 12.5729 12.3169 12.8169C12.0729 13.061 11.6771 13.061 11.4331 12.8169L10 11.3839L8.56694 12.8169C8.32286 13.061 7.92714 13.061 7.68306 12.8169C7.43898 12.5729 7.43898 12.1771 7.68306 11.9331L9.11612 10.5L7.68306 9.06694C7.43898 8.82286 7.43898 8.42714 7.68306 8.18306Z",
    fill: "#747D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.8f8ac6d4da0e91e0fbf14b4369ac0393.svg";
export { ForwardRef as ReactComponent };